import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriverCustomerConfigsQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type GetDriverCustomerConfigsQuery = { __typename?: 'query_root', usertocustomers: Array<{ __typename?: 'usertocustomers', customer_id: number, customer: { __typename?: 'customers', id: number, name?: string | null, tier: string, config?: object | null, organization?: { __typename?: 'organizations', id: number, config?: object | null } | null } }> };


export const GetDriverCustomerConfigsDocument = gql`
    query GetDriverCustomerConfigs($userId: bigint!) {
  usertocustomers(where: {user_id: {_eq: $userId}}) {
    customer_id
    customer {
      id
      name
      tier
      config
      organization {
        id
        config
      }
    }
  }
}
    `;

/**
 * __useGetDriverCustomerConfigsQuery__
 *
 * To run a query within a React component, call `useGetDriverCustomerConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverCustomerConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverCustomerConfigsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDriverCustomerConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables> & ({ variables: GetDriverCustomerConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>(GetDriverCustomerConfigsDocument, options);
      }
export function useGetDriverCustomerConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>(GetDriverCustomerConfigsDocument, options);
        }
// @ts-ignore
export function useGetDriverCustomerConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>;
export function useGetDriverCustomerConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverCustomerConfigsQuery | undefined, GetDriverCustomerConfigsQueryVariables>;
export function useGetDriverCustomerConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>(GetDriverCustomerConfigsDocument, options);
        }
export type GetDriverCustomerConfigsQueryHookResult = ReturnType<typeof useGetDriverCustomerConfigsQuery>;
export type GetDriverCustomerConfigsLazyQueryHookResult = ReturnType<typeof useGetDriverCustomerConfigsLazyQuery>;
export type GetDriverCustomerConfigsSuspenseQueryHookResult = ReturnType<typeof useGetDriverCustomerConfigsSuspenseQuery>;
export type GetDriverCustomerConfigsQueryResult = Apollo.QueryResult<GetDriverCustomerConfigsQuery, GetDriverCustomerConfigsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/getDriverCustomerConfigs.query.gql}
 */
export async function getDriverCustomerConfigs(
  variables: GetDriverCustomerConfigsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverCustomerConfigsQuery['usertocustomers']>
export async function getDriverCustomerConfigs(
  variables: GetDriverCustomerConfigsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverCustomerConfigsQuery>
export async function getDriverCustomerConfigs(
  variables: GetDriverCustomerConfigsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverCustomerConfigsQuery['usertocustomers'] | GetDriverCustomerConfigsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverCustomerConfigsQuery>(
    GetDriverCustomerConfigsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.usertocustomers
}